import React, { useState } from "react";
import "./common.css";
import API_URL from "../common/Apiurl";
import SuccessMessage from "../common/Message";
import { AiFillEye } from "react-icons/ai";

function Addadmin() {
  // add admin
  const apiUrl = API_URL;
  const [successMessages, setSuccessMessages] = useState([]);
  const [inputType, setInputType] = useState("password");
  const [rindustry, setRIndustry] = useState(false);
  const [windustry, setWindustry] = useState(false);
  const [rcategory, setRcategory] = useState(false);
  const [wcategory, setWcategory] = useState(false);
  const [rsubcat, setRsubcat] = useState(false);
  const [wsubcat, setWsubcat] = useState(false);
  const [rque, setRque] = useState(false);
  const [wque, setWque] = useState(false);
  const [rjobs, setRjobs] = useState(false);
  const [wjobs, setWjobs] = useState(false);

  const [rufeedback, setRufeedback] = useState(false);
  const [wufeedback, setWufeedback] = useState(false);
  const [rfeedback, setRfeedback] = useState(false);
  const [wfeedback, setWfeedback] = useState(false);
  const [remployers, setRemployers] = useState(false);
  const [wemployers, setWemployers] = useState(false);
  const [rhomeowners, setRhomeowners] = useState(false);
  const [whomeowners, setWhomeowners] = useState(false);
  const [rproviders, setRproviders] = useState(false);

  const [wproviders, setWproviders] = useState(false);
  const [rincompleteusers, setRincompleteusers] = useState(false);
  const [wincompleteusers, setWincompleteusers] = useState(false);
  const [rcredits, setRcredits] = useState(false);
  const [wcredits, setWcredits] = useState(false);
  const [rwallets, setRwallets] = useState(false);
  const [wwallets, setWwallets] = useState(false);
  const [rterms, setRterms] = useState(false);
  const [wterms, setWterms] = useState(false);
  const [rprivacy, setRprivacy] = useState(false);
  const [wprivacy, setWprivacy] = useState(false);
  const [rabout, setRabout] = useState(false);
  const [wabout, setWabout] = useState(false);
  const [rauditlogs, setRauditlogs] = useState(false);
  const [wauditlogs, setWauditlogs] = useState(false);
  const [is_super_admin, setSuperAdmin] = useState(false);

  const clicktoaddadmin = async (e) => {
    e.preventDefault();
    const admindata = new FormData(e.target);
    const firstname = admindata.get("firstname");
    const lastname = admindata.get("lastname");
    const email = admindata.get("email");
    const contact = admindata.get("contact");
    const password = admindata.get("password");
    const accessbility = {
      industry: {
        read: rindustry,
        write: windustry,
      },
      category: {
        read: rcategory,
        write: wcategory,
      },
      subcat: {
        read: rsubcat,
        write: wsubcat,
      },
      que: {
        read: rque,
        write: wque,
      },
      jobs: {
        read: rjobs,
        write: wjobs,
      },
      ufeedback: {
        read: rufeedback,
        write: wufeedback,
      },
      feedback: {
        read: rfeedback,
        write: wfeedback,
      },
      employers: {
        read: remployers,
        write: wemployers,
      },
      homeowners: {
        read: rhomeowners,
        write: whomeowners,
      },
      providers: {
        read: rproviders,
        write: wproviders,
      },
      incompleteusers: {
        read: rincompleteusers,
        write: wincompleteusers,
      },
      credits: {
        read: rcredits,
        write: wcredits,
      },
      wallets: {
        read: rwallets,
        write: wwallets,
      },
      terms: {
        read: rterms,
        write: wterms,
      },
      privacy: {
        read: rprivacy,
        write: wprivacy,
      },
      about: {
        read: rabout,
        write: wabout,
      },
      auditlogs: {
        read: rauditlogs,
        write: wauditlogs,
      },
    };
    const postData = {
      firstname: firstname,
      lastname: lastname,
      email: email,
      contactnumber: contact,
      password: password,
      accessbility: accessbility,
      is_super_admin: is_super_admin
    };
    const result = await fetch(`${apiUrl}/admin/createadmin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(postData),
    });
    const data = await result.json();
    if (data.status == 200) {
      const newSuccessMessage = data.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else if (data.status == 400) {
      const newSuccessMessage = data.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
  };

  const passShow = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    window.location.reload();
  };
  // add admin
  return (
    <div className="width90">
      <h2 className="pageTitle">Add Admin</h2>
      <div className="commonCntr">
        <form className="form-horizontal" onSubmit={clicktoaddadmin}>
          <div className="form-group">
            <label className="control-label col-sm-2 label" htmlFor="firstname">
              First Name:
            </label>
            <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                id="firstname"
                name="firstname"
                placeholder="Enter First name"
                required
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <label className="control-label col-sm-2 label" htmlFor="lastname">
              Last Name:
            </label>
            <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                id="lastname"
                name="lastname"
                placeholder="Enter Last name"
                required
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <label className="control-label col-sm-2 label" htmlFor="email">
              Email:
            </label>
            <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter Email"
                required
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <label className="control-label col-sm-2 label" htmlFor="contact">
              Contact Number:
            </label>
            <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                id="contact"
                name="contact"
                placeholder="Enter Contact Number"
                required
              />
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Password:</label>
            <div className="col-sm-4  mt-1 position-relative">
              <input
                type={inputType}
                className="form-control"
                name="password"
                id="password"
                required
              />
              <AiFillEye className="hide_show" onClick={passShow} />
            </div>
          </div>
          <div className="form-group mt-3">
            <div className="col-sm-4">
              <input
                type="checkbox"
                id="is_admin"
                value="1"
                name="is_admin"
                checked={is_super_admin}
                onChange={() => {
                  setSuperAdmin(!is_super_admin);
                  // if (is_super_admin === true) {
                    setRIndustry(1);
                    setWindustry(1);
                    setRcategory(1);
                    setWcategory(1);
                    setRsubcat(1);
                    setWsubcat(1);
                    setRque(1);
                    setWque(1);
                    setRjobs(1);
                    setWjobs(1);
                    setRufeedback(1);
                    setWufeedback(1);
                    setRfeedback(1);
                    setWfeedback(1);
                    setRemployers(1);
                    setWemployers(1);
                    setRhomeowners(1);
                    setWhomeowners(1);
                    setRproviders(1);

                    setWproviders(1);
                    setRincompleteusers(1);
                    setWincompleteusers(1);
                    setRcredits(1);
                    setWcredits(1);
                    setRwallets(1);
                    setWwallets(1);
                    setRterms(1);
                    setWterms(1);
                    setRprivacy(1);
                    setWprivacy(1);
                    setRabout(1);
                    setWabout(1);
                    setRauditlogs(1);
                    setWauditlogs(1);
                  // }
                }}
              />{" "}
              Is Super Admin
            </div>
          </div>

          {is_super_admin ? null : (
            <div className="form-group mt-3">
              <label className="control-label col-sm-2 label" htmlFor="contact">
                Accessbility:
              </label>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="industry">
                    Industry:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_industry"
                    checked={rindustry}
                    onChange={() => {
                      setRIndustry(!rindustry);
                    }}
                    value="1"
                    name="read_industry"
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_industry"
                    value="1"
                    checked={windustry}
                    onChange={() => {
                      setWindustry(!windustry);
                    }}
                    name="write_industry"
                  />{" "}
                  Read/Edit
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="category">
                    Category:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_Category"
                    value="1"
                    name="read_Category"
                    checked={rcategory}
                    onChange={() => {
                      setRcategory(!rcategory);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_Category"
                    value="1"
                    name="write_Category"
                    checked={wcategory}
                    onChange={() => {
                      setWcategory(!wcategory);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="sub_Category">
                    SubCategory:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_sub_Category"
                    value="1"
                    name="read_sub_Category"
                    checked={rsubcat}
                    onChange={() => {
                      setRsubcat(!rsubcat);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_sub_Category"
                    value="1"
                    name="write_sub_Category"
                    checked={wsubcat}
                    onChange={() => {
                      setWsubcat(!wsubcat);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="questions">
                    Questions:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_questions"
                    value="1"
                    name="read_questions"
                    checked={rque}
                    onChange={() => {
                      setRque(!rque);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_questions"
                    value="1"
                    name="write_questions"
                    checked={wque}
                    onChange={() => {
                      setWque(!wque);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="jobs">
                    Jobs:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_jobs"
                    value="1"
                    name="read_jobs"
                    checked={rjobs}
                    onChange={() => {
                      setRjobs(!rjobs);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_jobs"
                    value="1"
                    name="write_jobs"
                    checked={wjobs}
                    onChange={() => {
                      setWjobs(!wjobs);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label
                    className="control-label label"
                    htmlFor="user_feedback"
                  >
                    UserFeedback:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_user_feedback"
                    value="1"
                    name="read_user_feedback"
                    checked={rufeedback}
                    onChange={() => {
                      setRufeedback(!rufeedback);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_user_feedback"
                    value="1"
                    name="write_user_feedback"
                    checked={wufeedback}
                    onChange={() => {
                      setWufeedback(!wufeedback);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="feedback">
                    Feedback:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_feedback"
                    value="1"
                    name="read_feedback"
                    checked={rfeedback}
                    onChange={() => {
                      setRfeedback(!rfeedback);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_feedback"
                    value="1"
                    name="write_feedback"
                    checked={wfeedback}
                    onChange={() => {
                      setWfeedback(!wfeedback);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="employers">
                    Employers:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_employers"
                    value="1"
                    name="read_employers"
                    checked={remployers}
                    onChange={() => {
                      setRemployers(!remployers);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_employers"
                    value="1"
                    name="write_employers"
                    checked={wemployers}
                    onChange={() => {
                      setWemployers(!wemployers);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="homeowners">
                    Homeowners:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_homeowners"
                    value="1"
                    name="read_homeowners"
                    checked={rhomeowners}
                    onChange={() => {
                      setRhomeowners(!rhomeowners);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_homeowners"
                    value="1"
                    name="write_homeowners"
                    checked={whomeowners}
                    onChange={() => {
                      setWhomeowners(!whomeowners);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="providers">
                    Providers:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_providers"
                    value="1"
                    name="read_providers"
                    checked={rproviders}
                    onChange={() => {
                      setRproviders(!rproviders);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_providers"
                    value="1"
                    name="write_providers"
                    checked={wproviders}
                    onChange={() => {
                      setWproviders(!wproviders);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label
                    className="control-label label"
                    htmlFor="incomplete_users"
                  >
                    Incomplete Users:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_incomplete_users"
                    value="1"
                    name="read_incomplete_users"
                    checked={rincompleteusers}
                    onChange={() => {
                      setRincompleteusers(!rincompleteusers);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_incomplete_users"
                    value="1"
                    name="write_incomplete_users"
                    checked={wincompleteusers}
                    onChange={() => {
                      setWincompleteusers(!wincompleteusers);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="credit">
                    Credit:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_credit"
                    value="1"
                    name="read_credit"
                    checked={rcredits}
                    onChange={() => {
                      setRcredits(!rcredits);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_credit"
                    value="1"
                    name="write_credit"
                    checked={wcredits}
                    onChange={() => {
                      setWcredits(!wcredits);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="wallet">
                    Wallet:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_wallet"
                    value="1"
                    name="read_wallet"
                    checked={rwallets}
                    onChange={() => {
                      setRwallets(!rwallets);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_wallet"
                    value="1"
                    name="write_wallet"
                    checked={wwallets}
                    onChange={() => {
                      setWwallets(!wwallets);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="audit_logs">
                    Audit Log:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_audit_logs"
                    value="1"
                    name="read_audit_logs"
                    checked={rauditlogs}
                    onChange={() => {
                      setRauditlogs(!rauditlogs);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_audit_logs"
                    value="1"
                    name="write_audit_logs"
                    checked={wauditlogs}
                    onChange={() => {
                      setWauditlogs(!wauditlogs);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="about">
                    About us:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_about"
                    value="1"
                    name="read_about"
                    checked={rabout}
                    onChange={() => {
                      setRabout(!rabout);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_about"
                    value="1"
                    name="write_about"
                    checked={wabout}
                    onChange={() => {
                      setWabout(!wabout);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="privacy">
                    Privacy Policy:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_privacy"
                    value="1"
                    name="read_privacy"
                    checked={rprivacy}
                    onChange={() => {
                      setRprivacy(!rprivacy);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_privacy"
                    value="1"
                    name="write_privacy"
                    checked={wprivacy}
                    onChange={() => {
                      setWprivacy(!wprivacy);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>

              <div className="row">
                <div className="col-sm-4">
                  <label className="control-label label" htmlFor="terms">
                    Terms & Conditions:
                  </label>
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="read_terms"
                    value="1"
                    name="read_terms"
                    checked={rterms}
                    onChange={() => {
                      setRterms(!rterms);
                    }}
                  />{" "}
                  Read Only
                </div>
                <div className="col-sm-4">
                  <input
                    type="checkbox"
                    id="write_terms"
                    value="1"
                    name="write_terms"
                    checked={wterms}
                    onChange={() => {
                      setWterms(!wterms);
                    }}
                  />{" "}
                  Read/Edit
                </div>
              </div>
            </div>
          )}
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-default submitBtn">
                Submit
              </button>
            </div>
          </div>
        </form>
        {successMessages.map((message, index) => (
          <SuccessMessage
            key={index}
            message={message}
            onFadeOut={handleSuccessMessageFadeOut}
          />
        ))}
      </div>
    </div>
  );
}

export default Addadmin;
